import styled from 'styled-components';
import { Typography as MTypography, ButtonBase } from '@material-ui/core';
import 'boxicons/css/boxicons.min.css';

export const Container = styled.div<{ colors: string[]; height: string }>`
  background: ${(props) => props.colors[0]};
  height: ${(props) => props.height};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Icon = styled.i<{ overridecolor: string }>`
  color: ${(props) => props.overridecolor};
  padding: 5px;
  font-size: 24px;
`;

export const Typography = styled(MTypography)<{ overridecolor: string }>`
  color: ${(props) => props.overridecolor};
  font-size: 22px !important;
`;

export const BackButtonContainer = styled(ButtonBase)``;

export const ReloadButtonContainer = styled(ButtonBase)``;
